import {booleanAttribute, Component, computed, input} from '@angular/core';
import {Env} from '../ui-colors';

const ENV_NAMES: Record<Env, string> = {P: 'Productie', A: 'Acceptatie', T: 'Test', L: 'Local'};

/**
 * 18×18 environment letter (P/A/T/L) in the environment colors.
 * With `showName` the environment name follows; projected content (e.g. a URL) comes after that.
 */
@Component({
    selector: 'app-env-badge',
    templateUrl: './env-badge.component.html',
    styleUrl: './env-badge.component.scss'
})
export class EnvBadgeComponent {
    readonly env = input.required<Env>();
    readonly showName = input(false, {transform: booleanAttribute});
    readonly name = computed(() => ENV_NAMES[this.env()]);
}
